<div class="flex flex-col justify-center hidden md:flex">
  <mat-icon
    (mouseenter)="tooltipVisible = true"
    (mouseout)="tooltipVisible = false"
    class="ml-2 transform rotate-180 cursor-default icon-16"
    cdkOverlayOrigin
    #trigger="cdkOverlayOrigin"
    >error_outline</mat-icon
  >
  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="tooltipVisible"
    [cdkConnectedOverlayPositions]="tooltipPositions"
  >
    <div class="px-4 py-3 text-sm bg-white rounded shadow-xl md:text-xs">
      <div>{{ liability.title }}</div>
      <div *ngIf="liability.status === BalanceItemPaymentStatus.NOT_OVERDUE">Przed terminem płatności</div>
      <div *ngIf="liability.status === BalanceItemPaymentStatus.OVERDUE" class="text-red-600">
        Termin płatności minął
      </div>
      <div>
        <span>Termin płatności: </span>
        <span class="font-semibold">{{ liability.paymentDue }}</span>
      </div>
    </div>
  </ng-template>
</div>

<div class="text-sm md:hidden md:text-xs">
  <span [class.text-red-600]="liability.status === BalanceItemPaymentStatus.OVERDUE">{{ liability.paymentDue }}</span>
</div>
